import React, { useMemo } from "react";

import { Tab, TabProps } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props extends TabProps {
  to: string;
  unreadCount?: number;
}

const useStyles = makeStyles()((theme) => ({
  tab: {
    padding: 0,
    minWidth: 120, // width of "appointment" is 80, the longest label + 20 padding-left + 20 padding-right
    minHeight: 38, // line-height + 10 padding-top + 10 padding-bottom
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "18px",
    color: colors.gray,
    opacity: 1,
    textTransform: "none",
  },
  selected: {
    color: theme.palette.primary.main,
  },
  label: {
    position: "relative",
  },
  unreadIndicator: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: -10, // 4px size + 6px margin
    width: 4,
    height: 4,
    borderRadius: "50%",
    backgroundColor: "#F94848",
  },
}));

const HeaderTab: React.FC<Props> = ({
  to,
  label,
  unreadCount = 0,
  ...tabProps
}) => {
  const { classes } = useStyles();

  const renderLink = useMemo(() => {
    const Link = React.forwardRef<HTMLAnchorElement>((itemProps, ref) => {
      return <RouterLink to={to} ref={ref} {...itemProps} />;
    });
    Link.displayName = "Link";
    return Link;
  }, [to]);

  return (
    <Tab
      className={classes.tab}
      classes={{
        selected: classes.selected,
      }}
      label={
        <div className={classes.label}>
          {label}
          {unreadCount > 0 && <div className={classes.unreadIndicator} />}
        </div>
      }
      {...tabProps}
      component={renderLink as any}
    /> // `as any` in renderLink as Tab component prop only accepts HTMLDivElement and not HTMLAnchorElement
  );
};

export default HeaderTab;
